import React from 'react';
import { FaInstagram, FaLinkedinIn, FaWhatsapp, FaEnvelope, FaPhone } from 'react-icons/fa';
import ContactForm from './ContactForm';

const Contact = () => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center p-8 bg-white text-black rtl text-right">
      <div className="w-full md:w-1/2 mb-8 md:mb-0">
        <ContactForm />
      </div>
      <div className="w-full md:w-1/2 text-right">
        <h2 className="text-3xl font-bold mb-4">צור קשר</h2>
        <p className="text-lg mb-6"> !מעוניינים לשפר את הסיכויים שלכם לבלוט בתהליכי הגיוס? צרו קשר</p>
        <p className="mb-4 text-pink-500"> shovalrecruiting@gmail.com<FaEnvelope className="inline-block ml-2 text-pink-500 " /><strong className='text-pink-500 '> :אימייל</strong></p>
        <p className="mb-4 text-purple-500"> <strong className='text-purple-500'>טלפון: </strong><FaPhone className="inline-block ml-2 text-purple-500" />0533478176</p>
        <div className="flex space-x-4 mt-4 justify-end">
          <a href="https://www.instagram.com/shovalsaada.career/profilecard/?igsh=cHViZmNpaWVlbHNl" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="text-xl " />
          </a>
          <a href="https://www.linkedin.com/in/shoval-saada-3a65121b6/" target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn className="text-xl" />
          </a>
          <a href="https://wa.me/972528136536" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp className="text-xl" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;